export default "__VITE_ASSET__B_k09YtV__"